/**
 * Messages für aktiven Spieler (Du bist dran)
 */

// Erste Runde - Muss niedrigste Karte spielen
export const FIRST_TURN = [
  "Du startest Runde {round}. Deine niedrigste Karte muss raus - keine Diskussion.",
  "Runde {round}! Du fängst an. Niedrigste Karte, los!",
  "Du hast die niedrigste Karte. Spiel sie aus, Anfänger!",
  "Los geht's! Du eröffnest mit deiner Schrott-Karte.",
];

// Stich gewonnen - Neuer Start
export const ROUND_STARTER = [
  "Du hast den Stich. Leg was Neues vor, König.",
  "Der Tisch ist leer, du hast gewonnen. Mach den Anfang!",
  "Dein Stich! Zeit für was Frisches.",
  "Alles gepasst. Du bist der Boss jetzt.",
];

// Kann schlagen
export const CAN_PLAY = [
  "Dein Zug. Schlag es oder bereue es.",
  "Da liegt was. Zeig, was du drauf hast!",
  "Entscheid dich: Schlagen oder Feigling sein?",
  "Zeit für Action. Du kannst das toppen!",
];

// Muss ziehen
export const MUST_DRAW = [
  "Keine passende Karte. Zieh eine und heul leise.",
  "Tja, nix passt. Ab zum Stapel, Loser.",
  "Zieh 'ne Karte - deine Hand ist nutzlos.",
  "Nichts dabei? Dann zieh halt. Pech gehabt.",
];

// Muss passen (kein Stapel)
export const MUST_PASS = [
  "Keine Karten, kein Stapel. Pass und schäm dich.",
  "Nix in der Hand, nix zum Ziehen. Pass!",
  "Totale Ebbe. Du musst passen, Kumpel.",
];

// Hat Schild
export const HAS_SHIELD = [
  "Du könntest passen... oder dein Schild opfern. Deine Wahl.",
  "Schild verfügbar! Passen ohne Strafe möglich.",
  "Feigling-Option: Schild nutzen. Held-Option: Kämpfen.",
];

// Fast fertig (1-2 Karten)
export const ALMOST_DONE = [
  "Noch {count} Karte(n). Jetzt nicht verkacken!",
  "Fast geschafft! Noch {count} Karte(n) loswerden.",
  "Endspurt! {count} Karte(n) bis zum Sieg.",
  "So nah! Noch {count}. Mach keinen Fehler!",
];

// Gegner hat nur 1 Karte
export const OPPONENT_WARNING = [
  "Achtung! {name} hat nur noch eine Karte. Block oder stirb.",
  "ALARM! {name} ist fast raus. Tu was dagegen!",
  "Vorsicht: {name} ist einen Zug vom Sieg entfernt!",
  "{name} hat noch eine Karte. Blockier den Bastard!",
];

// Kann Flush spielen
export const CAN_FLUSH = [
  "Ein Flush? Zeig ihnen, was Farbe bedeutet.",
  "Flush möglich! Zeit für den Farbknaller.",
  "Du hast 'nen Flush. Mach den Laden dicht!",
];

// Kann Straße spielen
export const CAN_STRAIGHT = [
  "Straße frei! Lass es krachen.",
  "Eine Straße wartet. Zeig's ihnen!",
  "Straight-Option! Das sitzt.",
];

// Nur hohe Karten übrig
export const ONLY_HIGH_CARDS = [
  "Nur Hohe? Viel Spaß beim Loswerden, Bonze.",
  "Lauter hohe Karten. Erstklassiges Problem.",
  "Deine Hand stinkt nach Reichtum. Werde sie los!",
];

// Kann höchste 2 spielen (Reset)
export const CAN_RESET = [
  "Die höchste 2! Reset-Zeit. Alle heulen gleich.",
  "Du hast DIE Zwei. Wirf die Bombe!",
  "Reset möglich! Die höchste 2 wartet.",
];

// Generisch (Fallback)
export const GENERIC = [
  "Dein Zug, Champion. Mach was draus!",
  "Du bist dran. Zeig's ihnen!",
  "Action! Du bist am Drücker.",
  "Los geht's! Was spielst du?",
];

// Kann nicht schlagen (Round-Starter darf nicht passen)
export const CANT_PASS_STARTER = [
  "Runden-Starter darf nicht passen! Spiel was!",
  "Nee nee, du hast angefangen - also weitermachen!",
  "Du hast den Stich gewonnen. Passen geht nicht!",
];
